export default "__VITE_ASSET__Bd68CCvh__"